<template>
    <div>
        <div v-responsive.lg.xl class="pt-5">
             <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
             <section>
                <div class="mt-5 paralax-cover-image has-background-dim">
                    <div class="paralax-cover-image-text">
                    <div class="content_home" style="z-index: 1!important;">
                        <h1 style="text-align:left;font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('assurances.assurances_auto.header_title[0]') }}</span></h1>
                        <h1 style="text-align:left;font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('assurances.assurances_auto.header_title[1]') }}</span></h1>
                    </div>
                </div>
                </div>
            </section>
        </div>
        <div v-responsive.sm.xs class="pt-5">
             <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
             <section>
                <div class="paralax-cover-image_mobile has-background-dim_mobile">
                    <p class="paralax-cover-image-text_mobile">
                        <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                            <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('assurances.assurances_auto.header_title[0]') }}</span></h1>
                            <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('assurances.assurances_auto.header_title[1]') }}</span></h1>
                        </div>
                    </p>
                </div>
            </section>
        </div>
      <!-- <Banner title="Assurance Auto/Moto" image-path="assurance/auto.jpg"></Banner> -->
      <!-- <Banner v-responsive.sm.xs title="Assurance Auto/Moto" image-path="assurance/auto_mobile.jpg"></Banner> -->
      <div class="row containers">
          <div class="col-md-7 col-sm-12">
              <div class="grid-flex">
                  <div class="col col-image-auto"></div>
                  <div class="col col-text">
                      <div class="Aligner-item">
                          <p>
                            &ldquo;{{ $t('assurances.assurances_auto.kiray_say_text') }}&rdquo;
                            <cite>- Kiray Assuraf</cite>
                          </p>
                      </div>
                  </div>
              </div>
              <div class="justify-content-center row">
                <div class="pa-2 text-justify subheading font-weight-blod pl-md-5 pr-md-5" style="margin-bottom:-50px">
                    {{ $t('assurances.assurances_auto.texte_intro[0]') }} 
                    <span class="font-weight-bold">{{ $t('assurances.assurances_auto.texte_intro[1]') }}</span><br><br>
                    {{ $t('assurances.assurances_auto.texte_intro[2]') }} <br><br> 
                    {{ $t('assurances.assurances_auto.texte_intro[3]') }}
                    <div class="trigger_auto mt-3 mb-5">
                        <span> 
                            <a href="/devis/auto" style="text-decoration: none;color: #000000">
                                {{ $t('assurances.assurances_auto.bouton_devis_gratuit') }}
                            </a>
                            <i style="font-size: 20px" class="ml-4 fas fa-chevron-right "></i>
                        </span>
                    </div>
                </div>
              </div>
          </div>
          <div class="divider mr-3 ml-3">
              <v-divider vertical></v-divider>
          </div>
          <div class="col-md-4 col-sm-12 mt-5">
              <DropdowAssurancePage>
                  <template #label>
                    {{ $t('assurances.assurances_auto.first_question_title') }}
                  </template>
                    {{ $t('assurances.assurances_auto.first_question_content[0]') }} <br>
                    <span style="color: #ffa409">
                        {{ $t('assurances.assurances_auto.first_question_content[1]') }}
                    </span>
              </DropdowAssurancePage>
              <DropdowAssurancePage>
                  <template #label>
                    {{ $t('assurances.assurances_auto.second_question_title') }}
                  </template>
                  {{ $t('assurances.assurances_auto.second_question_content[0]') }}
              </DropdowAssurancePage>
  
              <DropdowAssurancePage>
                <template #label>
                {{ $t('assurances.assurances_auto.third_question_title') }}
                </template>
                {{ $t('assurances.assurances_auto.third_question_content[0]') }} <br>
                {{ $t('assurances.assurances_auto.third_question_content[1]') }} <br>
                <v-flex class="grey lighten-3 mt-3 ml-3 border-radius justify-content-center column">
                <div>
                    <div class="pb-3 pt-3 text-justify">
                    <p class="headline font-weight-bold ml-2" style="color: #ffa409">{{ $t('assurances.assurances_auto.third_question_tab_title_1') }}</p>
                    <ul style="list-style:none" class="ml-3 mr-3">
                        <li class="font-weight-bold" style="font-size: 18px">{{ $t('assurances.assurances_auto.third_question_tab_name[0]') }}</li>
                        <li>{{ $t('assurances.assurances_auto.third_question_tab_name[1]') }} <span class="mr-2" style="color:#ffa409;float:right">{{ $t('assurances.assurances_auto.third_question_tab_1_value[0]') }}</span></li>
                        <li>{{ $t('assurances.assurances_auto.third_question_tab_name[2]') }} <span class="mr-2" style="color:#ffa409;float:right">{{ $t('assurances.assurances_auto.third_question_tab_1_value[1]') }}</span></li>
                        <li>{{ $t('assurances.assurances_auto.third_question_tab_name[3]') }} <span class="mr-2" style="color:#ffa409;float:right">{{ $t('assurances.assurances_auto.third_question_tab_1_value[2]') }}</span></li>
                    </ul>
                    </div>
                </div>
                <div>
                    <div class="pb-3 pt-3 text-justify">
                    <p class="headline font-weight-bold ml-2" style="color: #ffa409">{{ $t('assurances.assurances_auto.third_question_tab_title_2') }}</p>
                    <ul style="list-style:none" class="ml-3 mr-3">
                        <li class="font-weight-bold" style="font-size: 18px">{{ $t('assurances.assurances_auto.third_question_tab_name[0]') }}</li>
                        <li>{{ $t('assurances.assurances_auto.third_question_tab_name[1]') }} <span class="mr-2" style="color:#ffa409;float:right">{{ $t('assurances.assurances_auto.third_question_tab_2_value[0]') }}</span></li>
                        <li>{{ $t('assurances.assurances_auto.third_question_tab_name[2]') }} <span class="mr-2" style="color:#ffa409;float:right">{{ $t('assurances.assurances_auto.third_question_tab_2_value[1]') }}</span></li>
                        <li>{{ $t('assurances.assurances_auto.third_question_tab_name[3]') }} <span class="mr-2" style="color:#ffa409;float:right">{{ $t('assurances.assurances_auto.third_question_tab_2_value[2]') }}</span></li>
                    </ul>
                    </div>
                </div>
                <div>
                    <div class="pb-3 pt-3 text-justify">
                    <p class="headline font-weight-bold ml-2" style="color: #ffa409">{{ $t('assurances.assurances_auto.third_question_tab_title_3') }}</p>
                    <ul style="list-style:none"  class="ml-3 mr-3">
                        <li class="font-weight-bold" style="font-size: 18px">{{ $t('assurances.assurances_auto.third_question_tab_name[0]') }}</li>
                        <li>{{ $t('assurances.assurances_auto.third_question_tab_name[1]') }} <span class="mr-2" style="color:#ffa409;float:right">{{ $t('assurances.assurances_auto.third_question_tab_3_value[0]') }}</span></li>
                        <li>{{ $t('assurances.assurances_auto.third_question_tab_name[2]') }} <span class="mr-2" style="color:#ffa409;float:right">{{ $t('assurances.assurances_auto.third_question_tab_3_value[1]') }}</span></li>
                        <li>{{ $t('assurances.assurances_auto.third_question_tab_name[3]') }} <span class="mr-2" style="color:#ffa409;float:right">{{ $t('assurances.assurances_auto.third_question_tab_3_value[2]') }}</span></li>
                    </ul>
                    </div>
                </div>
                </v-flex> <br>
                <span style="color: #ffa409">{{ $t('assurances.assurances_auto.third_question_content[2]') }}</span>
              </DropdowAssurancePage>
  
              <DropdowAssurancePage>
                  <template #label>
                    {{ $t('assurances.assurances_auto.four_question_title') }}
                  </template>
                  {{ $t('assurances.assurances_auto.four_question_content[0]') }}
              </DropdowAssurancePage>
              <DropdowAssurancePage>
                  <template #label>
                    {{ $t('assurances.assurances_auto.five_question_title') }}
                  </template>
                  {{ $t('assurances.assurances_auto.five_question_content[0]') }}
              </DropdowAssurancePage>
              <DropdowAssurancePage>
                  <template #label>
                    {{ $t('assurances.assurances_auto.six_question_title') }}
                  </template>
                  {{ $t('assurances.assurances_auto.six_question_content[0]') }}<br>
                  {{ $t('assurances.assurances_auto.six_question_content[1]') }}
              </DropdowAssurancePage>
              <DropdowAssurancePage>
                  <template #label>
                    {{ $t('assurances.assurances_auto.seven_question_title') }}
                  </template>
                    {{ $t('assurances.assurances_auto.seven_question_content[0]') }} <br>
                    <span style="color: #ffa409">
                        {{ $t('assurances.assurances_auto.seven_question_content[1]') }}
                    </span>
              </DropdowAssurancePage>
              <DropdowAssurancePage>
                  <template #label>
                    {{ $t('assurances.assurances_auto.first_question_title') }}
                  </template>
                    {{ $t('assurances.assurances_auto.first_question_content[0]') }} <br>
                    <span style="color: #ffa409">
                        {{ $t('assurances.assurances_auto.first_question_content[1]') }}
                    </span>
              </DropdowAssurancePage>
              <DropdowAssurancePage>
                  <template #label>
                    {{ $t('assurances.assurances_auto.eight_question_title') }}
                  </template>
                    {{ $t('assurances.assurances_auto.eight_question_content[0]') }} <br>
                    <span style="color: #ffa409">
                        {{ $t('assurances.assurances_auto.eight_question_content[1]') }}
                    </span>
              </DropdowAssurancePage>
              <DropdowAssurancePage>
                  <template #label>
                    {{ $t('assurances.assurances_auto.nine_question_title') }}
                  </template>
                    {{ $t('assurances.assurances_auto.nine_question_content[0]') }} <br>
                    <span style="color: #ffa409">
                        {{ $t('assurances.assurances_auto.nine_question_content[1]') }}
                    </span>
                    {{ $t('assurances.assurances_auto.nine_question_content[2]') }}
              </DropdowAssurancePage>
              <DropdowAssurancePage>
                  <template #label>
                    {{ $t('assurances.assurances_auto.ten_question_title') }}
                  </template>
                  {{ $t('assurances.assurances_auto.ten_question_content[0]') }} "<span style="color:#ffa409">{{ $t('assurances.assurances_auto.ten_question_content[1]') }}</span>"
                  {{ $t('assurances.assurances_auto.ten_question_content[2]') }} <br>
                  {{ $t('assurances.assurances_auto.ten_question_content[3]') }}
              </DropdowAssurancePage>
          </div>
      </div>

      
    </div>
  </template>
  
  <script>
  import Banner from '../layouts/banners/banner.vue';
  import DropdowAssurancePage from './DropdowAssurancePage.vue';
  
  export default {
      name: 'DescriptionAssuranceVieComponent',
      components: {
          Banner,
          DropdowAssurancePage
      }
  }
  </script>
  
  <style scoped>
  .containers {
      padding: 20px 8%;
      /* display: flex; */
  }
  .trigger_auto{
      width: 300px;
  }
  .trigger_auto span {
      font-weight: bold;
      font-size: 16px;
      background: #ffa409;
      color: #000000;
      height: 50px;
      padding: 0 18px;
      cursor: pointer;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      justify-content: center;
  }
  .grid-flex {
      margin-top: 5%;
  }
  
  @media only screen and (max-width: 767px) {
      .divider {
          display: none;
      }
  }

  .paralax-cover-image {
        background-image: url('../../assets/img/assurance/auto.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 210px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 50px;
    }


  .paralax-cover-image_mobile {
        background-image: url('../../assets/img/assurance/auto_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
       /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        /* background-attachment: fixed; */
        background-position: 100% 40px;
    }
  </style>